import { createAction } from '@reduxjs/toolkit';

export const UPDATE_ANSWER_RULE_PRIORITY_ACTION_TYPE = 'saga/updateAnswerRulePriority';
export const updateAnswerRulePriorityAction = createAction(UPDATE_ANSWER_RULE_PRIORITY_ACTION_TYPE);
